import React, { useState, useContext } from 'react';
import { Container, Form, Button, Card, Alert } from 'react-bootstrap';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Context } from '../index';
import { LOGIN_ROUTE, REGISTRATION_ROUTE, SHOP_ROUTE } from '../routes';
import { registration, login } from '../http/userAPI';

const Auth = () => {
    const { user } = useContext(Context);
    const location = useLocation();
    const navigate = useNavigate();
    const isLogin = location.pathname === LOGIN_ROUTE;

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            let userData;
            if (isLogin) {
                userData = await login(email, password);
            } else {
                userData = await registration(email, password);
            }

            // userData уже декодирован:
            console.log('Данные пользователя:', userData);
            // { id: 1, email: 'test@mail.ru', role: 'ADMIN', iat: ..., exp: ... }

            user.setIsAuth(true);
            user.setUser(userData);
            navigate(SHOP_ROUTE);
        } catch (error) {
            setError(error.response?.data?.message || 'Ошибка');
        }
    };

    return (
        <Container
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: '80vh' }}
        >
            <Card style={{ width: '450px' }} className="shadow-lg">
                <Card.Body className="p-5">
                    <h2 className="text-center mb-4">
                        {isLogin ? 'Вход' : 'Регистрация'}
                    </h2>

                    {error && (
                        <Alert variant="danger" className="text-center">
                            {error}
                        </Alert>
                    )}

                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Введите email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label>Пароль</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Введите пароль"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </Form.Group>

                        <Button
                            variant="dark"
                            type="submit"
                            className="w-100 mb-3"
                            size="lg"
                        >
                            {isLogin ? 'Войти' : 'Зарегистрироваться'}
                        </Button>

                        <div className="text-center">
                            {isLogin ? (
                                <span>
                                    Нет аккаунта?{' '}
                                    <NavLink
                                        to={REGISTRATION_ROUTE}
                                        style={{ color: '#0d6efd', textDecoration: 'none' }}
                                    >
                                        Зарегистрироваться
                                    </NavLink>
                                </span>
                            ) : (
                                <span>
                                    Уже есть аккаунт?{' '}
                                    <NavLink
                                        to={LOGIN_ROUTE}
                                        style={{ color: '#0d6efd', textDecoration: 'none' }}
                                    >
                                        Войти
                                    </NavLink>
                                </span>
                            )}
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default observer(Auth);